import Service from "./Service"

class ProductProjectIterationService extends Service {

    findById = (id) => this.get(`/product-projects/iterations/${id}`)

    search = (queryParams) => this.getWithParams("/product-projects/iterations", queryParams)

    searchCustomers = (queryParams) => this.getWithParams("/product-projects/iterations/customers", queryParams)

    create = (productProjectId, request) => this.post(`/product-projects/${productProjectId}/iterations`, request)

    update = (id, request) => this.patch(`/product-projects/iterations/${id}`, request)

    close = (id) => this.patch(`/product-projects/iterations/${id}/close`)

    delete = (id) => this.del(`/product-projects/iterations/${id}`)
}

const productProjectIterationService = new ProductProjectIterationService()
export default productProjectIterationService